
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PaymentModeGrid extends Serenity.EntityGrid<PaymentModeRow, any> {
        protected getColumnsKey() { return 'OMS.PaymentMode'; }
        protected getDialogType() { return PaymentModeDialog; }
        protected getIdProperty() { return PaymentModeRow.idProperty; }
        protected getInsertPermission() { return PaymentModeRow.insertPermission; }
        protected getLocalTextPrefix() { return PaymentModeRow.localTextPrefix; }
        protected getService() { return PaymentModeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}